<template>
  <div class="flex flex-col mt-5 h-full">
    <template v-if="subOrder.highComplexity">
      <p class="mb-1 font-serif text-xl text-center text-gray-700 md:mb-2 md:text-2xl">
        ¡Este pedido es de <span class="uppercase">alta complejidad</span>!
      </p>
      <ExclamationTriangleIcon class="shrink-0 self-center w-32 h-32 text-lk-green md:w-40 md:h-40" />
      <p class="text-sm font-light text-left md:text-base">
        Este pedido pasará primero por nuestra oficina y luego será enviado por un transportista
        adicional. Asegúrate de:
      </p>
      <ul class="px-5 mt-2 text-sm font-light list-disc text-left md:text-base">
        <li>
          <b>El pedido este completo.</b> Haz doble revisión ya que errores a este destino serán difíciles de corregir.
        </li>
        <li>
          <b>Embalar con doble precaución los productos.</b>
          Estos pasarán por al menos dos transportistas, por lo que queremos evitar productos rotos.
        </li>
        <li>Incluir la <b>guía de despacho Lokal</b>.</li>
        <li>Los bultos estén correctamente etiquetados.</li>
      </ul>
    </template>
    <template v-else>
      <p class="mb-1 font-serif text-xl text-center text-gray-700 md:mb-2 md:text-2xl">
        Antes de enviar tus pedidos
      </p>
      <DocumentChartBarIcon class="shrink-0 self-center w-32 h-32 text-lk-green md:w-40 md:h-40" />
      <p class="text-base font-light text-center md:text-lg">
        <span class="font-normal">Recuerda</span>
        incluir la
        <span class="font-normal">guía de despacho Lokal</span>
        en los bultos para que las tiendas puedan recibir tus pedidos.
      </p>
    </template>
    <button
      class="p-2 mt-auto text-sm text-lk-green hover:text-white hover:bg-lk-green rounded-md border border-lk-green md:text-base"
      type="button"
      @click="emit('update:modelValue', true)"
    >
      Continuar
    </button>
  </div>
</template>
<script lang="ts" setup>
import { DocumentChartBarIcon, ExclamationTriangleIcon } from '@heroicons/vue/24/outline';

interface SubOrderShipmentReminderProps {
  modelValue: boolean
  subOrder: SubOrder
}

defineProps<SubOrderShipmentReminderProps>();

const emit = defineEmits<{(e: 'update:modelValue', value: boolean): void}>();
</script>
